import { isLoading } from "apollo/utils";
import { useEnvContext } from "context/EnvContext";
import { APP_CAREPROVIDER } from "core/consts";
import { useManualSetLegalDocuments } from "dsl/atoms/LegalDocuments";
import { useHandleLogin } from "dsl/ecosystems/CareproviderOnboardingLoginPage/useHandleLogin";
import { LoginPageV2 } from "dsl/ecosystems/LoginPageV2";
import {
  loginPageModelDefinition,
  validateChallenge,
  validateLogin,
} from "dsl/ecosystems/LoginPageV2/formConfig";
import { useCareproviderHandlerUrls } from "dsl/hooks/useNavigationHandlers";
import { SimpleFormRenderProps } from "react-forms-state/src";

export function CareproviderLoginPage({
  careproviderToLog,
}: {
  careproviderToLog?: number;
}) {
  const { env } = useEnvContext();

  const {
    challengeTimestamp,
    handleLogin,
    isLogin,
    loginErrors,
    loginView,
    progressLogin,
    resetError,
    setLoginView,
    setProgressLogin,
  } = useHandleLogin({ careproviderToLog });

  const {
    goToContactUs,
    goToForgotPassword,
    goToProductionEnv,
    goToSenderApp,
  } = useCareproviderHandlerUrls();

  // Setting the legal documents to default on the login screen, otherwise
  // it tries to fetch with the id (logout/onboarding), although logged out
  useManualSetLegalDocuments();

  return (
    <main>
      <SimpleFormRenderProps
        asHtmlForm
        modelDefinition={loginPageModelDefinition}
        validate={isLogin ? validateLogin : validateChallenge}
        onSubmit={(props) => handleLogin(props, setProgressLogin)}
      >
        {({ onChange, submit }) => (
          <LoginPageV2
            app={APP_CAREPROVIDER}
            challengeTimestamp={challengeTimestamp}
            contactUsUrl={goToContactUs()}
            env={env}
            goToForgotPassword={goToForgotPassword()}
            goToProductionUrl={goToProductionEnv()}
            isLoading={isLoading(progressLogin)}
            loginErrors={loginErrors}
            loginView={loginView}
            otherAppUrl={goToSenderApp()}
            resetError={resetError}
            onBackToLogin={() => {
              onChange(null, "challenge", true);
              onChange(null, "email", true);
              onChange(null, "password", true);
              resetError();
              setLoginView("login");
            }}
            onSubmit={submit}
          />
        )}
      </SimpleFormRenderProps>
    </main>
  );
}
